import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PortfolioMasterPage.css'; // Reuse or create BrokerMasterPage.css for styles
import { API_BASE_URL } from '../services/api';

const BROKER_TYPES = ['MM', 'FX', 'Gsec', 'Stock', 'Other'];

export default function BrokerMasterPage() {
  const [tab, setTab] = useState('add');
  const [brokers, setBrokers] = useState([]);
  const [form, setForm] = useState(initialForm());
  const [search, setSearch] = useState('');
  const [editId, setEditId] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { fetchBrokers(); }, []);

  function initialForm() {
    return {
      broker_code: '', broker_name: '', building_number: '', street_name: '', street_name2: '', city: '', province: '', zip_code: '', country: '', contact_name: '', contact_phone: '', contact_mobile: '', contact_fax: '', contact_email: '', broker_type: '', brokerage_method: 'Cal Method', brokerage_cal_method_id: '', brokerage_input_percentage: '', brokerage_settlement_method_id: '', settlement_account_number: ''
    };
  }

  async function fetchBrokers() {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/brokers`);
      setBrokers(res.data);
    } catch (e) { setError('Failed to fetch brokers'); }
    setLoading(false);
  }

  function handleChange(e) {
    const { name, value, type } = e.target;
    setForm(f => ({ ...f, [name]: type === 'number' ? Number(value) : value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (editId) {
        await axios.put(`${API_BASE_URL}/brokers/${editId}`, form);
        setShowEdit(false);
      } else {
        await axios.post(`${API_BASE_URL}/brokers`, form);
      }
      setForm(initialForm());
      fetchBrokers();
    } catch (e) {
      setError(e.response?.data?.error || 'Save failed');
    }
    setLoading(false);
  }

  function startEdit(broker) {
    setEditId(broker.id);
    setForm(broker);
    setShowEdit(true);
    setTab('add');
  }

  async function handleDelete(id) {
    if (!window.confirm('Delete this broker?')) return;
    setLoading(true);
    try {
      await axios.delete(`${API_BASE_URL}/brokers/${id}`);
      fetchBrokers();
    } catch (e) { setError('Delete failed'); }
    setLoading(false);
  }

  const filteredBrokers = search ? brokers.filter(b => b.broker_name.toLowerCase().includes(search.toLowerCase()) || b.broker_code.toLowerCase().includes(search.toLowerCase())) : brokers;

  return (
    <div className="master-page">
      <div className="tabs">
        <button className={tab==='add' ? 'active' : ''} onClick={()=>{setTab('add');setShowEdit(false);setForm(initialForm());}}>Add Broker</button>
        <button className={tab==='search' ? 'active' : ''} onClick={()=>setTab('search')}>Search Broker</button>
      </div>

      {tab === 'add' && (
        <form className="master-form" onSubmit={handleSubmit}>
          <div className="row">
            <label>Broker Code</label>
            <input name="broker_code" value={form.broker_code} onChange={handleChange} required />
            <label>Broker Name</label>
            <input name="broker_name" value={form.broker_name} onChange={handleChange} required />
          </div>
          <fieldset>
            <legend>Address</legend>
            <div className="row">
              <input placeholder="Building Number" name="building_number" value={form.building_number} onChange={handleChange} />
              <input placeholder="Street Name" name="street_name" value={form.street_name} onChange={handleChange} />
              <input placeholder="Street Name 2" name="street_name2" value={form.street_name2} onChange={handleChange} />
              <input placeholder="City" name="city" value={form.city} onChange={handleChange} />
              <input placeholder="Province" name="province" value={form.province} onChange={handleChange} />
              <input placeholder="Zip Code" name="zip_code" value={form.zip_code} onChange={handleChange} />
              <input placeholder="Country" name="country" value={form.country} onChange={handleChange} />
            </div>
          </fieldset>
          <fieldset>
            <legend>Contact Details</legend>
            <div className="row">
              <input placeholder="Name" name="contact_name" value={form.contact_name} onChange={handleChange} />
              <input placeholder="Phone" name="contact_phone" value={form.contact_phone} onChange={handleChange} />
              <input placeholder="Mobile" name="contact_mobile" value={form.contact_mobile} onChange={handleChange} />
              <input placeholder="Fax" name="contact_fax" value={form.contact_fax} onChange={handleChange} />
              <input placeholder="Email" name="contact_email" value={form.contact_email} onChange={handleChange} />
            </div>
          </fieldset>
          <div className="row">
            <label>Broker Type</label>
            <select name="broker_type" value={form.broker_type} onChange={handleChange} required>
              <option value="">Select Type</option>
              {BROKER_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="row">
            <label>Brokerage</label>
            <label><input type="radio" name="brokerage_method" value="Cal Method" checked={form.brokerage_method==='Cal Method'} onChange={handleChange} /> Cal Method</label>
            <label><input type="radio" name="brokerage_method" value="Input %" checked={form.brokerage_method==='Input %'} onChange={handleChange} /> Input %</label>
            {form.brokerage_method === 'Cal Method' ? (
              <input placeholder="Cal Method ID" name="brokerage_cal_method_id" value={form.brokerage_cal_method_id} onChange={handleChange} />
            ) : (
              <input placeholder="Input Percentage" name="brokerage_input_percentage" value={form.brokerage_input_percentage} onChange={handleChange} type="number" step="0.0001" />
            )}
          </div>
          <div className="row">
            <label>Brokerage Settlement Method</label>
            <input placeholder="Settlement Method ID" name="brokerage_settlement_method_id" value={form.brokerage_settlement_method_id} onChange={handleChange} />
            <label>Settlement Account Number</label>
            <input name="settlement_account_number" value={form.settlement_account_number} onChange={handleChange} />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={loading}>{editId ? 'Update' : 'Add'} Broker</button>
          {showEdit && <button type="button" onClick={()=>{setShowEdit(false);setEditId(null);setForm(initialForm());}}>Cancel Edit</button>}
        </form>
      )}

      {tab === 'search' && (
        <div>
          <input placeholder="Search by name or code..." value={search} onChange={e=>setSearch(e.target.value)} />
          <table className="master-table">
            <thead>
              <tr>
                <th>Code</th><th>Name</th><th>Type</th><th>Contact</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredBrokers.length === 0 && (
                <tr><td colSpan="5">No brokers found.</td></tr>
              )}
              {filteredBrokers.map(b => (
                <tr key={b.id}>
                  <td>{b.broker_code}</td>
                  <td>{b.broker_name}</td>
                  <td>{b.broker_type}</td>
                  <td>{b.contact_name}</td>
                  <td>
                    <button onClick={()=>startEdit(b)}>Edit</button>
                    <button onClick={()=>handleDelete(b.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
